(() => {
  const ROOT_SELECTOR = '[data-collapsible]';
  const TRIGGER_SELECTOR = '[data-collapsible-trigger]';
  const CONTENT_SELECTOR = '[data-collapsible-content]';
  let collapsibleIdCounter = 0;

  const setExpandedState = (wrapper, isOpen) => {
    const header = wrapper.querySelector(TRIGGER_SELECTOR);
    const content = wrapper.querySelector(CONTENT_SELECTOR);

    if (!header || !content) return;

    wrapper.classList.toggle('is-open', isOpen);
    header.classList.toggle('is-open', isOpen);
    content.classList.toggle('with-slow-transition', isOpen);
    header.setAttribute('aria-expanded', String(isOpen));
    content.setAttribute('aria-hidden', String(!isOpen));
  };

  const closeSiblings = (root, currentWrapper) => {
    root.querySelectorAll('.collapsible__wrapper.is-open').forEach((wrapper) => {
      if (wrapper === currentWrapper) return;
      setExpandedState(wrapper, false);
    });
  };

  const handleTriggerClick = (event) => {
    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    const root = trigger.closest(ROOT_SELECTOR);
    const wrapper = trigger.closest('.collapsible__wrapper');
    if (!root || !wrapper) return;

    event.preventDefault();

    const isOpen = wrapper.classList.contains('is-open');
    if (isOpen) {
      setExpandedState(wrapper, false);
      return;
    }

    const exclusiveContainer = root.closest('.new-product__inf-wrapper') || root;
    closeSiblings(exclusiveContainer, wrapper);
    setExpandedState(wrapper, true);
  };

  const handleTriggerKeyDown = (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    event.preventDefault();
    trigger.click();
  };

  const wireAccessibility = (wrapper) => {
    const header = wrapper.querySelector(TRIGGER_SELECTOR);
    const content = wrapper.querySelector(CONTENT_SELECTOR);
    if (!header || !content) return;

    if (!header.hasAttribute('role')) {
      header.setAttribute('role', 'button');
    }

    if (!header.hasAttribute('tabindex')) {
      header.setAttribute('tabindex', '0');
    }

    if (!content.id) {
      collapsibleIdCounter += 1;
      content.id = `ofra-collapsible-content-${collapsibleIdCounter}`;
    }

    header.setAttribute('aria-controls', content.id);
  };

  const hydrate = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      root.querySelectorAll('.collapsible__wrapper').forEach((wrapper) => {
        wireAccessibility(wrapper);
        const isOpen = wrapper.classList.contains('is-open');
        setExpandedState(wrapper, isOpen);
      });
    });
  };

  const boot = () => {
    if (window.__ofraCollapsibleInitialized) {
      hydrate(document);
      return;
    }

    window.__ofraCollapsibleInitialized = true;
    document.addEventListener('click', handleTriggerClick);
    document.addEventListener('keydown', handleTriggerKeyDown);

    hydrate(document);

    document.addEventListener('shopify:section:load', (event) => {
      hydrate(event.target);
    });

    document.addEventListener('product-info:loaded', (event) => {
      hydrate(event.target);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();